module.exports = __webpack_public_path__ + "static/media/apple-core.84fc1b26.svg";